import item from '../CollectionItems/muralForTheTerracePlazaHotel';

export default {
  location: 'sunflowers',
  filename: 'sunflowers-van-gogh',
  title: item.name,
};
